import React from "react";
import { ISurveyQuestion } from "../../../models/survey/survey-question.model";
import { surveyValueInput } from "./survey-answer-question-card.module.scss";

export interface ISurveyAnswerInputNumberProps {
    question: ISurveyQuestion;
    value: string | number | null;
    onChange: (value: string | number) => void;
}

const SurveyAnswerInputNumber: React.FC<ISurveyAnswerInputNumberProps> = ({
    question,
    value,
    onChange,
}) => {
    const { unit, placeholder } = question;

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = e.target.value;
        if (unit) {
            onChange(inputValue);
        } else {
            const numValue = parseFloat(inputValue);
            onChange(isNaN(numValue) ? inputValue : numValue);
        }
    };

    return (
        <input
            type="text"
            className={surveyValueInput}
            value={value || ""}
            onChange={handleChange}
            placeholder={placeholder || ""}
            aria-label={question.title}
        />
    );
};

export default SurveyAnswerInputNumber;
